import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    currentSlot: String,
    slot: String,
    path: String,
    sizes: Object,
    unmountOnConnect: {
      type: Boolean,
      default: false
    }
  }

  connect() {
    if (this.unmountOnConnectValue) this.unmount()
  }

  mount() {
    this.send("vetomatic:mount", {
      slot: this.slotValue, path: this.pathValue, sizes: this.sizesValue
    });
  }

  unmount() {
    this.send("vetomatic:unmount", { slot: this.currentSlotValue });
  }

  send(type, payload) {
    window.parent.postMessage({ type, ...payload }, "*");
  }
}
